import { globalRef } from '@amazon/vinyl-util'
import type { QueueViewResult } from './queueViewService'

type QueueEdge = NonNullable<NonNullable<QueueViewResult['queue']>['view']>['edges'][number]

export interface QueueViewSnapshot {
    readonly queueId: string
    readonly view: QueueViewResult
    readonly history: QueueEdge[]
    readonly nextCursor: string | null
    readonly hasMore: boolean
    readonly historyHasMore: boolean
    readonly mutatedAt: number
    readonly epoch: number
}

const cacheRef = globalRef(() => ({ snapshot: null as QueueViewSnapshot | null, epoch: 0 }))

export function currentQueueViewEpoch(): number {
    return cacheRef.value.epoch
}

export function invalidateQueueViewCache(): void {
    cacheRef.value.epoch++
    cacheRef.value.snapshot = null
}

export function saveQueueViewSnapshot(next: QueueViewSnapshot): void {
    cacheRef.value.snapshot = next
}

export function takeQueueViewSnapshot(
    queueId: string,
    mutatedAt: number
): QueueViewSnapshot | null {
    const { snapshot: held, epoch } = cacheRef.value
    if (!held || held.queueId !== queueId || held.mutatedAt !== mutatedAt || held.epoch !== epoch) {
        return null
    }
    return held
}
